import { render } from "./DSTSelector.vue?vue&type=template&id=516d77f0&scoped=true"
import script from "./DSTSelector.vue?vue&type=script&lang=js"
export * from "./DSTSelector.vue?vue&type=script&lang=js"

import "./DSTSelector.vue?vue&type=style&index=0&id=516d77f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-516d77f0"]])

export default __exports__